import { getGeminiAdoptionTrendWeekPeriods } from '@workalizer/shared/lib/gemini-usage-level/adoptionTrend';
import { resolveGeminiUsageLevelPeriod } from '@workalizer/shared/lib/gemini-usage-level/period';
export var GEMINI_USAGE_LEVEL_DISTRIBUTION_MIN_WEEKS = 1;
export var isGeminiUsageLevelDistributionVisible = function (dateFrom, dateTo, minWeeks) {
    if (minWeeks === void 0) { minWeeks = GEMINI_USAGE_LEVEL_DISTRIBUTION_MIN_WEEKS; }
    var periodInfo = resolveGeminiUsageLevelPeriod(dateFrom, dateTo);
    return periodInfo.isValid && periodInfo.weekCount >= minWeeks;
};
export var getGeminiUsageLevelDistributionWeekPeriods = function (dateFrom, dateTo, minWeeks) {
    if (minWeeks === void 0) { minWeeks = GEMINI_USAGE_LEVEL_DISTRIBUTION_MIN_WEEKS; }
    return getGeminiAdoptionTrendWeekPeriods(dateFrom, dateTo, minWeeks);
};
